// extracted by mini-css-extract-plugin
export var advertCtnHoriz = "game-play-page-styles-module--advert-ctn-horiz--991dc";
export var gameCtn = "game-play-page-styles-module--game-ctn--9d9e1";
export var gameFrame = "game-play-page-styles-module--game-frame--16adf";
export var pageCtn = "game-play-page-styles-module--page-ctn--6f112";